/**
 * NOTE: Intl use non-breaking space between characters.
 */
export const maskForAmount = (val: string): string => {
    const sanitizeAmount = val.replaceAll(/\D/g, '');

    // NOTE: We don't want to return '0' given an empty value
    if (!sanitizeAmount.length) {
        return '';
    }

    return new Intl.NumberFormat('fr-FR')
        .format(Number(sanitizeAmount));
};
